import { Component, Input, OnInit } from '@angular/core';
import { compact } from '@imcc/utilities';
import { PrefixedClassList } from '../../prefixed-class-list';
import { ISourceSet } from './i-source-set';

/**
 *
 * @property {string} prefix      - The prefix to use for CSS classes.
 * @property {string} src         - The src to the image with the smallest
 *                                  resolution.
 * @property {string} alt         - The alternate text for the image.
 * @property {ISourceSet} sources - Images to use at different screen widths.
 *
 * @export
 * @class ImageComponent
 */
@Component({
  selector: 'app-fm-image',
  templateUrl: './image.component.html',
})
export class ImageComponent implements OnInit {
  @Input()
  prefix = '';

  @Input()
  src = '';

  @Input()
  alt = '';

  @Input()
  fullWidth = false;

  @Input()
  sources: ISourceSet[] = [];

  @Input()
  additionalClasses: string[] = [];

  sortedSources: ISourceSet[];

  ngOnInit(): void {
    this.sortedSources = this.sources.sort(
      (a, b) => parseInt(a.maxWidth, 10) - parseInt(b.maxWidth, 10),
    );
  }

  get pictureClassNames(): string {
    return [
      new PrefixedClassList(
        this.prefix,
        ...compact(['image', this.widthClass]),
      ).toString(),
      ...this.additionalClasses,
    ].join(' ');
  }

  get widthClass(): string | undefined {
    if (this.fullWidth) {
      return 'image--100';
    }

    return undefined;
  }

  get imageClassNames(): string {
    return new PrefixedClassList(this.prefix, 'image__source').toString();
  }
}
